import { render, staticRenderFns } from "./EditViewTermReportsSubjectRecords.vue?vue&type=template&id=48903460&scoped=true&"
import script from "./EditViewTermReportsSubjectRecords.vue?vue&type=script&lang=js&"
export * from "./EditViewTermReportsSubjectRecords.vue?vue&type=script&lang=js&"
import style0 from "./EditViewTermReportsSubjectRecords.vue?vue&type=style&index=0&id=48903460&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48903460",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VCol,VDataTable,VRow,VSelect,VTextField,VTooltip})
